import { Td, Tr, Checkbox, IconButton } from '@cad-arc';
import { UnitStatusSearchForm, UnitStatusSearchRow } from '@mark43/cad-api';
import { useCallback, useState } from 'react';
import { ResultSelectionStore } from '../search-windows/use-observable-search-results-selection-store';
import { UnitStatusSearchResultsDateCell } from './unit-status-search-results-date-cell';
import { UnitStatusSearchResultsEventDetailsCell } from './unit-status-search-results-event-details-cell';
import { UnitStatusSearchResultsLocationCell } from './unit-status-search-results-location-cell';
import { UnitStatusSearchResultsStatusCell } from './unit-status-search-results-status-cell';
import { UnitStatusSearchResultsUnitCell } from './unit-status-search-results-unit-cell';

export function UnitStatusSearchResultRow({
    row,
    selection,
    searchData,
}: {
    row: UnitStatusSearchRow;
    selection: ResultSelectionStore;
    searchData?: UnitStatusSearchForm;
}) {
    const [isExpanded, setIsExpanded] = useState<boolean>(false);
    const toggleIsRowExpanded = useCallback(() => {
        setIsExpanded(!isExpanded);
    }, [isExpanded]);
    return (
        <Tr>
            <Td key="select" style={{ verticalAlign: 'middle' }}>
                <Checkbox
                    isChecked={!!selection.selectedItems[row.unitStatusRmsEventId]}
                    onChange={() => selection.toggleSelected(row.unitStatusRmsEventId)}
                />
            </Td>
            <Td key="date" style={{ verticalAlign: 'top' }}>
                <UnitStatusSearchResultsDateCell row={row} isExpanded={isExpanded} />
            </Td>
            <Td key="unit" style={{ verticalAlign: 'top' }}>
                <UnitStatusSearchResultsUnitCell row={row} isExpanded={isExpanded} />
            </Td>
            <Td key="status" style={{ verticalAlign: 'top' }}>
                <UnitStatusSearchResultsStatusCell row={row} isExpanded={isExpanded} />
            </Td>
            <Td key="event-details" style={{ verticalAlign: 'top' }}>
                <UnitStatusSearchResultsEventDetailsCell
                    row={row}
                    isExpanded={isExpanded}
                    searchData={searchData}
                />
            </Td>
            <Td key="location" style={{ verticalAlign: 'top' }}>
                <UnitStatusSearchResultsLocationCell row={row} isExpanded={isExpanded} />
            </Td>
            <Td key="row-expander" style={{ verticalAlign: 'top' }}>
                <IconButton
                    icon={isExpanded ? 'Close' : 'Open'}
                    variant="ghost"
                    aria-label="show / hide more info"
                    onClick={() => toggleIsRowExpanded()}
                />
            </Td>
        </Tr>
    );
}
